import { createClassName } from 'utils/createClassName';

import './accountControlsMobileLayoutStyles.scss';

export const createAccountControlsMobileLayoutClassName = createClassName(
  'accountControlsMobileLayout'
);
